import React from 'react';
import PropTypes from 'prop-types';
import generateIdSpecsEntry from '@/utils/Common/Compare/generateIdSpecsEntry';

// import components
import ComparePopupContentResultsAccordion from '@/kenwood/components/molecules/ComparePopupContentResultsAccordion';

const ComparePopupContentResults = ({
  productsCode,
  results,
  showDifferences,
  resultsGeneralSpecsLabel,
  resultsIdLabel,
}) => (
  <section className='ken-compare__popup__content__results'>
    <ComparePopupContentResultsAccordion
      productsCode={productsCode}
      content={generateIdSpecsEntry(resultsIdLabel, productsCode)}
      titleLabel={resultsGeneralSpecsLabel}
    />
    {Object.keys(results).map(key => (
      <ComparePopupContentResultsAccordion
        key={key}
        productsCode={productsCode}
        content={results[key]}
        showDifferences={showDifferences}
        titleLabel={key}
      />
    ))}
  </section>
);

ComparePopupContentResults.propTypes = {
  productsCode: PropTypes.arrayOf(PropTypes.string),
  results: PropTypes.shape(),
  showDifferences: PropTypes.bool,
  resultsGeneralSpecsLabel: PropTypes.string.isRequired,
  resultsIdLabel: PropTypes.string.isRequired,
};

ComparePopupContentResults.defaultProps = {
  productsCode: [],
  showDifferences: false,
  results: {},
};

export default ComparePopupContentResults;
